import type { Position, PositionsDto } from "../api/types";

export function carryLiveFields(incoming: PositionsDto, previous: PositionsDto | null): PositionsDto {
  if (!previous || previous.open.length === 0 || incoming.open.length === 0) return incoming;

  const previousById = new Map<string, Position>(previous.open.map((position) => [position.id, position]));
  let changed = false;
  const open = incoming.open.map((position) => {
    if (position.currentPrice !== undefined) return position;
    const known = previousById.get(position.id);
    if (!known || known.currentPrice === undefined) return position;
    changed = true;
    return { ...position, currentPrice: known.currentPrice, unrealizedPnlUsd: known.unrealizedPnlUsd };
  });

  return changed ? { ...incoming, open } : incoming;
}
